export default {"src":"/_next/static/media/alert.cd63ef21.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};